<template>
  <v-expansion-panel-content class="content-bg--2 fill-height">
    <v-layout
      column
      justify-space-between
      ma-0
      fill-height
      class="pb-5 pt-4 px-4 fill-height"
    >
      <div class="flex v-flex v-flex--border mb-4">
        <v-flex class="display-1 font-weight-bold d-flex fill-height">
          <div class="ma-auto text-xs-center">
            <router-link :to="{ name: card.action }">
              <icon-plus-circle></icon-plus-circle>
            </router-link>

            <div class="text-xs-center mt-3">{{ card.title }}</div>
          </div>
        </v-flex>
      </div>

      <div
        class="font-weight-medium mb-3 mt-3 subtitle-1"
        v-if="card.description"
      >
        {{ card.description }}
      </div>
    </v-layout>
  </v-expansion-panel-content>
</template>

<script>
import IconPlusCircle from "../icon/IconPlusCircle.vue";
export default {
  name: "NewCardForAdd",
  components: {
    IconPlusCircle,
  },

  props: {
    // информация на карточке
    card: {
      default: () => ({
        title: "",
        description: "",
        action: "",
      }),
      type: Object,
    },
  },
};
</script>
